import { useState, useCallback } from 'react';
import { forgotPassword } from '@/api/auth.api';

export const useForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [requestError, setRequestError] = useState('');
    const [successEmail, setSuccessEmail] = useState('');

    const handleForgotPassword = useCallback(async ({ email }) => {
        setLoading(true);
        setRequestError('');

        const data = await forgotPassword(email);

        if (data?.code === 200) {
            setSuccessEmail(email);
        } else {
            setRequestError(data?.error || 'Something went wrong. Please try again.');
        }

        setLoading(false);
    }, []);

    return { loading, requestError, successEmail, handleForgotPassword };
};